(() => {
  const links = document.querySelectorAll('[data-cr-back]');
  if (!links.length || !document.referrer || history.length < 2) return;
  let previous;
  try { previous = new URL(document.referrer); } catch { return; }
  if (previous.origin !== location.origin || previous.pathname === location.pathname) return;
  links.forEach(link => {
    link.href = previous.href;
    const label = link.querySelector('[data-cr-back-text]');
    if (label) label.textContent = link.dataset.crBackLabel;
    link.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      history.back();
    });
  });
})();
